import script from "./UpDrugsV310.vue?vue&type=script&setup=true&lang=js"
export * from "./UpDrugsV310.vue?vue&type=script&setup=true&lang=js"

import "./UpDrugsV310.vue?vue&type=style&index=0&id=ce84d9e0&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce84d9e0"]])

export default __exports__